import { render, staticRenderFns } from "./addquestionUpload.vue?vue&type=template&id=987ebc68"
import script from "./addquestionUpload.vue?vue&type=script&lang=js"
export * from "./addquestionUpload.vue?vue&type=script&lang=js"
import style0 from "./addquestionUpload.vue?vue&type=style&index=0&id=987ebc68&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports